

/*
	Source: htdocs/wim/js/core/src/LiveVideo.js
*/
(function($, wimbledonCore) {
/**
     *  handle Wimbledon Channel page and live video
     */
    function LiveVideo(_videoData, _replayData, _youtubeLink) {
        var id = 'LiveVideo';
        var logger = new eventsCore.util.Logger(id);
        var videoData = _videoData;
        var replayData = _replayData;
        var youtubeLink = _youtubeLink;
        var videoPlayer;
        var isPlaying = false;
        var isLive = false;

        var init = function() {

            // override live on first call since live_indicator may not be laoded yet
            checkLive(videoData.live);
            setInterval(checkLive, 20000);

            $(document).ready(function() {
                videoPlayer = wimbledonCore.videoPlayer.init('wimchan');
                videoPlayer.on('MeasureEvent', onMeasureEvent);
                videoPlayer.on('StartEvent', onStartEvent);
                videoPlayer.on('CompleteEvent', onCompleteEvent);

                logger.info('init - videoPlayer:%o', videoPlayer.id());

                var format = 'H:mm z';
                var bstTime = moment(parseFloat(videoData.startTime)).tz('Europe/London').format(format);
                var localFormat = 'h:mm A';
                var localTime = moment(parseFloat(videoData.startTime)).local().format(localFormat);
                //logger.info('init - formTime:%o local:%o', bstTime, localTime);

                $('.posterWrapper > .imageWrapper > img').attr('src', videoData.images.slate);

                $('.offAirWrapper > .message > .vodDescription').html(videoData.media.vod.title);
                $('.offAirWrapper > .imageWrapper > img').attr('src', videoData.media.vod.thumbnail);

                $('.offAirWrapper').find('.title.startTime').html('Join us at ' + bstTime + ' and ' + localTime + ' local time.'); 

                setupDisplay();

                $('.posterWrapper').on('click', function() {
                    loadLive();
                });

                $('.offAirWrapper').on('click', function() {
                    if (videoData.media.vod.url) {
                        var vod = {
                            "id": "wimchan",
                            "type": "vod",
                            "title": videoData.media.vod.title,
                            "contentType": "",
                            "pictureM": videoData.media.thumbnail,
                            "wwwdash": "",
                            "wwwhlshigh": videoData.media.vod.url,
                            "pdl": "",
                            "link": document.location.href
                        }

                        loadVod('wimchan', vod); 
                    }
                    
                });
            });
        };

        /**
         * setup display based on live state
         */
        var setupDisplay = function() {
            logger.info('setupDisplay - isLive:%o', isLive);

            if (isLive) {
                $('.posterWrapper').show();
            }
            else {
                //$('.offAirWrapper > .message').html('Off Air state, play vod.');
                $('.offAirWrapper').show();

                if (videoData.media.vod.title != '') {
                    $('.offAirWrapper > .message > .vodDescription').show();
                }
                else {
                    $('.offAirWrapper > .message > .vodDescription').hide();
                }

                if (videoData.media.vod.url != '') {
                    $('.offAirWrapper').find('.centered_icon').show();
                    $('.offAirWrapper').find('.title').removeClass('novod');
                }
                else {
                    $('.offAirWrapper').find('.centered_icon').hide();
                    $('.offAirWrapper').find('.title').addClass('novod');
                }
            }


            $('#wimbledonChannelArchiveDropdown').empty();
            $('#wimbledonChannelArchiveDropdown').append(
                '<option value="">-- Select to Play --</option>'
            );

            if (replayData && replayData.length > 0) {
                for (var i=0; i<replayData.length; i++){
                    $('#wimbledonChannelArchiveDropdown').append(
                        $('<option></option>').val(replayData[i].url).html(replayData[i].title)
                    );
                }

                $('#wimbledonChannelArchiveDropdown').off('change').on('change', function() {
                    logger.info('setupDisplay - archive channel:%o', this.value);

                    var replay = {
                        "id": "wimchan",
                        "type": "vod",
                        "title": "Wimbledon Channel - " + this.title,
                        "contentType": "",
                        "pictureM": "",
                        "wwwdash": "",
                        "wwwhlshigh": this.value,
                        "pdl": "",
                        "link": document.location.href
                    }

                    loadVod('wimchan', replay);
                });
                $('.channelArchive').show();
            }
            else {
                $('.channelArchive').hide();
            }
        }

        /**
         * load live video based on videodata from constructor
         */
        var loadLive = function() {
            $('.posterWrapper').hide();
            $('.offAirWrapper').hide();
            isPlaying = true;

            wimbledonCore.videoPlayer.loadLive({
                videoId: 'wimchan',
                videoTitle: 'Wimbledon Channel',
                videoData: videoData,
                streamType: 'live',
                contentType: 'live',
                link: document.location.href
            });
        };

        /**
         * load off air vod video based on videodata from constructor
         *  - open youtube link if flag is set to true, e
         */
        var loadVod = function(id, data) {
            if (!youtubeLink) {
                $('.posterWrapper').hide();
                $('.offAirWrapper').hide();
                isPlaying = true;

                logger.info('loadVod - id:%o videoData:%o', id, videoData);
                wimbledonCore.videoPlayer.load(id, {'videoData': data});
            }
            else {
                logger.info('loadVod - id:%o videoData:%o', id, data.wwwhlshigh);
                window.open(data.wwwhlshigh, '_blank');
            }
            
        };

        var onCompleteEvent = function() {
            logger.info('onCompleteEvent - ');
            
            isPlaying = false;
            setupDisplay();
            checkLive();
        };

        var onMeasureEvent = function(data) {
            logger.info('onMeasureEvent - data:%o type:%o', data, data.type);
        };

        var onStartEvent = function(data) {
            logger.info('onStartEvent - data:%o', data);
        };

        var onErrorEvent = function(data) {
            logger.info('onErrorEvent - data:%o', data);
            isPlaying = false;
        };

        /**
         * check live state as set by live_indicators.json
         *  - not using live flasg in video data for now
         */
        var checkLive = function(override) {
            var liveVal = (override != undefined) ? override : window.liveIndicator.video;

            logger.info('checkLive - isLive:%o liveVal:%o', isLive, liveVal);

            //handle switch to off-air
            if (isLive && !liveVal) {
                if (isPlaying) {
                    videoPlayer.stop();
                }
                isLive = liveVal;
                setupDisplay();
            }
            //handle switch to on-air
            else if (!isLive && liveVal && !isPlaying) {
                isLive = liveVal;
                setupDisplay();
            }

            
        }

        init();

        return {

        }
    };

    wimbledonCore.LiveVideo = LiveVideo;

}(jQuery, window.wimbledonCore));
